export default {
  // Do not change the position of the first color. It is explicitly for the 'Remaining' category key
  colors() {
    return ['#B1BCBC', '#3ACF80', '#70F2F2', '#B3F2C9', '#528C18', '#C3F25C']
  }
}
